// Class for error messages 
// Class for error messages 
export enum ValidationErrorMessage {
    REQUIRED = "This field is required",
    MIN_LENGTH = "Must be at least 3 characters .",
    MIN_LENGTH_FIVE = "Use 5 characters or more for your password",
    MIN_LENGTH_FOUR = "Use 4 characters or more for your password",
    MIN_LENGTH_TEN = "Must be 10 numbers .",
    MAX_LENGTH_TEN_NUMBERS = "Must be 10 numbers .",
    MAX_LENGTH = "Must not be more than 45 characters .",
    MIN_LENGTH_ONE = "Must be at least 1 characters .",
    MIN_LENGTH_THREE = "Must be at least 3 characters .",
    MAX_LENGTH_FIFTEEEN = "Must not be more than 15 characters .",
    MAX_LENGTH_TWENTY = "Must not be more than 20 characters .",
    MAX_LENGTH_FORTY_FIVE = "Must not be more than 45 characters .",
    MIN_LENGTH_TWO = "Must be at least 2 characters .",
    MAX_LENGTH_HUNDRED = "Must not be more than 100 characters .",
    MAX_LENGTH_TEN = "Must not be more than 10 characters .",
    MAX_LENGTH_ONE_FIFTY = "Must not be more than 150 characters .",
    MAX_LENGTH_TWO_HUNDRED = "Must not be more than 200 characters .",
    MAX_LENGTH_NINTYFIVE = "Must not be more than 95 characters .",
    MAX_LENGTH_THOUSAND = "Must not be more than 1000 characters .",
    MAX_LENGTH_SIXTY = "Must not be more than 60 characters .",
    MAX_LENGTH_FIVE_HUNDRED = "Must not be more than 500 characters .",
    MAX_LENGTH_TWO_HUNDRED_FIFTY = "Must not be more than 250 characters .",
    VALID_MOBILE = "Must be a valid mobile number",
    ALPHABET = "Only alphabets allowed",
    NUMBER = "only Numbers allowed",
    STRING = "only Characters allowed",
    PATTERN = "Password must contain characters and number",
    VALID_EMAIL = "Invalid Email",
    TERMS_AND_COND = "Please accept the terms and conditions",
    MAX_LENGTH_FIFTEEEN_NUMBER = "Must not be more than 15 number .",
    EMIAL_REQUIRED = "Enter your email id",
    PASWORD_REQUIRED = "Enter your password",
    PASSWORD_MUST_BE_SAME = "Confirm Password must be same as password ",
    IMAGE_SIZE = "Please Upload Image Lesser than 10MB",
    VALID_FAX="Must be a valid fax number",
    SPACE ="Space is Not Allowed",
  
    IMAGE_Type = "Image extension should be (.jpeg/.jpg/.png/.tif/.gif/.pdf)",
    IMAGE_Count = "Maximum 5 images only allowed",
    IMAGE_Count1 = "Each category takes only one image",
}